import { ProseType } from '@data/types';
import classNames from 'classnames';
import React from 'react';

interface Props extends ProseType {}

const Prose: React.FC<Props> = ({
  htmlContent,
  style = 'style-1',
  className = '',
}) => {
  return (
    <div
      className={classNames('prose', className, {
        'prose-h2:uppercase prose-h2:px-4 prose-h2:py-1 prose-h2:mb-4 prose-h2:inline-block prose-h2:text-xs prose-h2:bg-blue-light prose-h2:text-blue prose-h2:rounded-tl-lg prose-h2:rounded-br-lg prose-h2:font-lightNormal prose-p:text-white prose-h3:text-white prose-h3:text-2xl prose-h3:font-lightNormal prose-h3:leading-9 prose-p:leading-normal':
          style === 'style-1',
        'prose-h2:font-lightNormal prose-h2:text-xs prose-h2:bg-blue-light prose-h2:text-blue prose-h2:rounded-tl-lg prose-h2:rounded-br-lg md:max-w-md prose-h2:mb-4 prose-h2:inline-block prose-h2:uppercase prose-h2:px-4 prose-h2:py-1 prose-h3:font-lightNormal prose-h3:text-base prose-p:text-sm prose-p:font-lighterNormal prose-p:leading-normal':
          style === 'style-2',
        'first-of-type:prose-p:text-xl first-of-type:prose-p:font-lightNormal prose-strong:font-lightNormal prose-p:font-light prose-p:leading-normal first-of-type:prose-p:leading-snug prose-p:font-lighterNormal':
          style === 'style-3',
        'prose-p:text-sm prose-p:font-lighterNormal text-white prose-p:leading-normal':
          style === 'style-4',
        'prose-h2:uppercase prose-h2:px-4 prose-h2:py-1 prose-h2:inline-block prose-h2:text-xs prose-h2:bg-blue-light prose-h2:text-blue prose-h2:rounded-tl-lg prose-h2:rounded-br-l prose-p:text-white prose-p:text-sm prose-p:mt-4 prose-h3:text-white prose-h3:text-1xl prose-h3:leading-9':
          style === 'style-5',
        'prose-headings:text-white prose-h1:text-2xl lg:prose-h1:text-3xl text-center prose-p:text-sm prose-p:text-white':
          style === 'style-6',
        'text-sm prose-h3:text-lg prose-ul:list-disc prose-ul:list-outside':
          style === 'style-7',
      })}
      dangerouslySetInnerHTML={
        htmlContent ? { __html: htmlContent } : undefined
      }
    ></div>
  );
};

export default Prose;
